module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('form', {
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [(_vm.step == 1) ? _c('div', {}, [_vm._m(0), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "tel"
    }
  }, [_vm._v("手机号码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regTel),
      expression: "regTel"
    }],
    class: {
      error_bor: !_vm.isRegTel
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.regTel)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.regTel = $event.target.value
      }, function($event) {
        _vm.checkInput(1)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_num),
      expression: "flag_num"
    }],
    staticClass: "error_msg"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/img/error_msg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("仅支持数字的输入")])]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "verify"
    }
  }, [_vm._v("手机验证码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyNum),
      expression: "verifyNum"
    }],
    class: {
      error_bor: !_vm.isVerify
    },
    attrs: {
      "type": "text",
      "id": "verify",
      "maxlength": "6",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verifyNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button gray verify",
    class: {
      btn_resend: _vm.regTel.length == 11 && !_vm.waitCode, seconds: _vm.waitCode
    },
    attrs: {
      "type": "button"
    }
  }, [(_vm.check_tel && !_vm.waitCode) ? _c('span', {
    class: {
      col_fff: _vm.regTel.length == 11
    },
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    on: {
      "click": _vm.verifyTel
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.waitCode) ? _c('span', [_vm._v(_vm._s(_vm.wait) + "s后重试")]) : _vm._e(), _vm._v(" "), (!_vm.check_tel && !_vm.waitCode) ? _c('span', {
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("重新发送")]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "-40px"
    }
  }, [_c('button', {
    staticClass: "button gray btn_register",
    class: {
      btn_resend: _vm.verifyNum.length >= 6
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkNum
    }
  }, [_vm._v("下一步")])])]) : (_vm.step == 2) ? _c('div', {}, [_vm._m(1), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("真实姓名 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    class: {
      error_bor: _vm.flag_name
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入真实姓名",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }, function($event) {
        _vm.checkInput(2)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_name),
      expression: "flag_name"
    }],
    staticClass: "error_msg"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/img/error_msg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("仅支持2-10个汉字输入")])]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "passWord"
    }
  }, [_vm._v("密码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "passWord",
      "placeholder": "请输入密码",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.checkInput(3)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag_password),
      expression: "flag_password"
    }],
    staticClass: "error_msg"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/img/error_msg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("仅支持字母和数字的组合")])]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "passWord"
    }
  }, [_vm._v("确认密码 :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请再次输入密码",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-left": "-40px"
    }
  }, [_c('button', {
    staticClass: "button gray btn_register",
    class: {
      btn_resend: _vm.confirmPassword.length >= 6 && _vm.password.length >= 6
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("注册")])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headMsg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/cellphone.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "vertical-align": "sub"
    }
  }, [_vm._v("验证手机号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headMsg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/register_data.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("完善资料")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-445ea60a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/register.vue
// module id = 1194
// module chunks = 1